import React from "react"
import { graphql } from "gatsby"
import Helmet from "react-helmet"
import "./../../static/css/base.scss"
import favicon from './../../favicon.png'

class MasterLayout extends React.Component {
  render() {
    let siteMetadata = this.props.data.site.siteMetadata
    let location = this.props.location.pathname

    return (
      <div className="MasterLayout">
        <Helmet defaultTitle={siteMetadata.title}>
          <meta name="description" content={siteMetadata.siteDescr} />
          <meta name="keywords" content="articles" />
          <link rel='shortcut icon' type='image/png' href={favicon} />
        </Helmet>
        {this.props.children}
      </div>
    )
  }
}

export default MasterLayout
